/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PlatformCategory } from './platform-category';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccountAlbaoneFeed } from './sns-account-albaone-feed';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccountError } from './sns-account-error';
// May contain unused imports in some cases
// @ts-ignore
import type { User } from './user';

/**
 * 
 * @export
 * @interface AdminGetSnsAccountsForMkt24OkDto
 */
export interface AdminGetSnsAccountsForMkt24OkDto {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsAccountUuid': string;
    /**
     * sns 고유키
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsUniqueKey': string;
    /**
     * 계정 ID
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsId': string;
    /**
     * 계정 링크
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsLink': string;
    /**
     * sns 계정 종류
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsAccountType': AdminGetSnsAccountsForMkt24OkDtoSnsAccountTypeEnum;
    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'isActivity'?: boolean;
    /**
     * 승인 일시
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'approvedAt': string;
    /**
     * 성별
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'gender': AdminGetSnsAccountsForMkt24OkDtoGenderEnum;
    /**
     * 나이
     * @type {number}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'age': number;
    /**
     * 적립 금액
     * @type {number}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'totalPoint': number;
    /**
     * 관리자 체크 여부
     * @type {boolean}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'isCheck': boolean;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'createdAt': string;
    /**
     * 수정 일시
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'updatedAt': string;
    /**
     * 삭제 일시
     * @type {string}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'deletedAt': string;
    /**
     * 계정 버전
     * @type {number}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'version': number;
    /**
     * 유저
     * @type {User}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'user': User;
    /**
     * 플렛폼 카테고리
     * @type {PlatformCategory}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'platformCategory': PlatformCategory;
    /**
     * sns 계정 에러
     * @type {SnsAccountError}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsAccountError': SnsAccountError;
    /**
     * sns 계정 알바원 피드
     * @type {SnsAccountAlbaoneFeed}
     * @memberof AdminGetSnsAccountsForMkt24OkDto
     */
    'snsAccountAlbaoneFeed': SnsAccountAlbaoneFeed;
}

export const AdminGetSnsAccountsForMkt24OkDtoSnsAccountTypeEnum = {
    Viewup: 'viewup',
    ViewupPlus: 'viewupPlus'
} as const;

export type AdminGetSnsAccountsForMkt24OkDtoSnsAccountTypeEnum = typeof AdminGetSnsAccountsForMkt24OkDtoSnsAccountTypeEnum[keyof typeof AdminGetSnsAccountsForMkt24OkDtoSnsAccountTypeEnum];
export const AdminGetSnsAccountsForMkt24OkDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminGetSnsAccountsForMkt24OkDtoGenderEnum = typeof AdminGetSnsAccountsForMkt24OkDtoGenderEnum[keyof typeof AdminGetSnsAccountsForMkt24OkDtoGenderEnum];


